import { motion } from 'framer-motion'
import { X } from 'lucide-react'
import { ExpandedSpreadsheetProps } from '../types'

export const ExpandedSpreadsheet = ({ src, title, onClose }: ExpandedSpreadsheetProps) => {
  const handleClose = (e: React.MouseEvent) => {
    e.stopPropagation()
    onClose()
  }

  const formattedSrc = src.includes('embed.aspx') 
    ? src 
    : `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(src)}`

  return (
    <motion.div
      className='fixed inset-0 z-[10000] flex items-center justify-center bg-black/90'
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.15 }}
      onClick={(e) => e.stopPropagation()}
    >
      <button
        className='absolute right-4 top-4 z-[10001] flex h-10 w-10 items-center justify-center rounded-full bg-white/20 text-white transition-colors hover:bg-white/40'
        onClick={handleClose}
        aria-label='Close'
      >
        <X size={24} />
      </button>

      <motion.div
        className='h-[90vh] w-[90vw] bg-white rounded overflow-hidden'
        initial={{ scale: 0.9, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        exit={{ scale: 0.9, opacity: 0 }}
        transition={{ type: 'spring', stiffness: 300, damping: 25 }}
      >
        <iframe
          src={formattedSrc}
          title={title}
          className='h-full w-full border-0'
          style={{ display: 'block' }}
          allow="fullscreen"
        />
      </motion.div>
    </motion.div>
  )
} 